import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import SelectPaginated from '../../../../../components/SelectPaginated'
import { getLoadOptionsHandler } from '../../../../../features/helpers/componentsHelpers'

import {
  createSroiReportPayloadSelector,
  createSroiReportPayloadWasCreatedSelector,
  getSroiReportsIsLoadingSelector,
  updateSroiReportPayloadWasUpdatedSelector,
  deleteSroiReportPayloadWasDeletedSelector
} from '../../../../../modules/selectors/socialReturnOnInvestment'

import { getSroiReportsService } from '../../../../../modules/services/socialReturnOnInvestment'

import { useReportRefreshKey } from './hooks/useReportRefreshKey'
import { useReportSelection } from './hooks/useReportSelection'

import useStyles from './styles'

const ReportSelect = ({ selectedYear, selectedReport, setSelectedReport }) => {
  const classes = useStyles()

  const getSroiReportsIsLoading = useSelector(getSroiReportsIsLoadingSelector)
  const wasCreated = useSelector(createSroiReportPayloadWasCreatedSelector)
  const wasUpdated = useSelector(updateSroiReportPayloadWasUpdatedSelector)
  const wasDeleted = useSelector(deleteSroiReportPayloadWasDeletedSelector)
  const createSroiReportPayload = useSelector(createSroiReportPayloadSelector)

  const params = useMemo(() => {
    return selectedYear ? { yearOfReporting: selectedYear } : {}
  }, [selectedYear])

  const formatOptions = useCallback(options => {
    return options.map(item => ({
      ...item,
      value: item.id,
      label: item.title
    }))
  }, [])

  const loadOptions = useMemo(() => {
    return getLoadOptionsHandler({
      getOptionsService: getSroiReportsService,
      formatOptions: formatOptions,
      params
    })
  }, [formatOptions, params])

  const onChangeHandler = useCallback(
    value => {
      setSelectedReport(value)
    },
    [setSelectedReport]
  )

  const resetKey = useReportRefreshKey({ wasCreated, wasUpdated, wasDeleted, selectedYear })
  const onFetchedOptionsChange = useReportSelection({
    selectedReport,
    setSelectedReport,
    wasCreated,
    createSroiReportPayload
  })

  return (
    <SelectPaginated
      key={resetKey}
      onFetchedOptionsChange={onFetchedOptionsChange}
      loadOptions={loadOptions}
      shouldFetchDefaultOptions={true}
      value={selectedReport?.id}
      isLoading={getSroiReportsIsLoading}
      onChange={onChangeHandler}
      className={classes.reportSelect}
      placeholder="Select Report"
      isSearchable={false}
    />
  )
}

ReportSelect.propTypes = {
  selectedYear: PropTypes.number,
  selectedReport: PropTypes.object,
  setSelectedReport: PropTypes.func.isRequired
}

export default ReportSelect
